import React, { FC } from 'react';
import { useTerritoryDetailsModalContext } from '../TerritoryDetails/context/TerritoryDetailsModalContextProvider';
import TerritoryMembersModal from '../TerritoryMembersPopUp/TerritoryMembersModal';

type TerritoryMembersListModalComponentProps = {
  territoryName: string;
  members: any[];
  membersCount: number;
};

export const TerritoryMembersListModalComponent: FC<TerritoryMembersListModalComponentProps> = ({
  territoryName,
  members,
  membersCount,
}) => {
  const { ModalComponent } = useTerritoryDetailsModalContext();
  const headerText = `Members (${membersCount})`;

  return (
    <ModalComponent title={headerText}>
      <TerritoryMembersModal members={members} membersCount={membersCount} territoryName={territoryName || ''} />
    </ModalComponent>
  );
};
